import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { interval, Subscription } from 'rxjs';
import isEmpty from 'src/app/lib/isEmpty';
import { adminBotService } from 'src/app/services/bot.admin.service';


@Component({
  selector: 'app-adminBotpreview',
  templateUrl: './adminBotpreview.component.html',
  styleUrls: ['./adminBotpreview.component.css']
})
export class adminBotpreviewComponent {
  @Input() botDetails: any
  @Input() orderPlaceDet: any
  @Input() orderStep: any
  @Output() gotoStep = new EventEmitter<any>();
  showPrevious = false
  showLoaderPage = false
  loaderPercentage = 0
  startBot = false
  showTimer: boolean = false;
  isSubmitting = false;
  canStartBot: boolean = true;

  constructor(
    private service: adminBotService,
    private toastr: ToastrService,
  ) {
  }
  ngOnInit() {
    console.log(this.botDetails, '-----11')
  }
  handlePrevious() {
    this.showPrevious = true
    this.gotoStep.emit("one")
  }
  showBotCreateLoader(state: boolean) {
    this.showLoaderPage = state
    this.botTimer(state)
  }

  botTimer(state: boolean) {
    if (state) {
      const interval = setInterval(() => {
        if (this.loaderPercentage < 90) {
          this.loaderPercentage += 10;
        } else {
          clearInterval(interval); // stop at 90%
        }
      }, 1000);
    } else {
      // Finish to 100%
      const finishInterval = setInterval(() => {
        if (this.loaderPercentage < 100) {
          this.loaderPercentage += 10;
        } else {
          clearInterval(finishInterval);
        }
      }, 200);
    }
  }

  submitForm(reqData: any) {
    if (!this.canStartBot) return;
    this.isSubmitting = true;
    this.toastr.success("Please wait for a while");
    this.showBotCreateLoader(true)
    this.service.orderPlace(reqData).subscribe({
      next: (v: any) => {
        this.toastr.success(v.message);
        this.handlePrevious()
      },
      error: (err: any) => {
        this.isSubmitting = false;
        this.showBotCreateLoader(false)
        if ([400, 404].includes(err.status)) {
          if (err?.error?.message)
            this.toastr.error(err.error.message);

          const validationErrors = err.error.errors;
          if (!isEmpty(validationErrors)) {
            if (err?.error?.errors?.order) {
              this.toastr.error(err.error.errors.order);
            }
          }
        } else if (err.status === 500) {
          this.toastr.error(err.error.message);
        }
      },
    });
  }
}
